module.exports = __webpack_public_path__ + "static/media/medium_custom_pens.7a285ec8.jpg";